/**
 * AR-AFIP emitter profile builder.
 * Pure, framework-agnostic module: maps the invoicing configuration record
 * (invoicingItem.invoicingData.data) + branch address to the emitter shape
 * shared by the invoice PDF and the thermal invoice ticket.
 */

export interface IArAfipEmitter {
  razonSocial: string | null;
  condicionIva: string | null;
  domicilio: string | null;
  ingresosBrutos: string | null;
  inicioActividades: string | null;
}

export function buildArAfipEmitter(
  config: Record<string, unknown>,
  branchAddress: string | null
): IArAfipEmitter {
  return {
    razonSocial: typeof config.name === 'string' ? config.name : null,
    condicionIva:
      config.businessCategory === 'm'
        ? 'Responsable Monotributo'
        : 'IVA Responsable Inscripto',
    domicilio: branchAddress,
    ingresosBrutos:
      typeof config.ingresosBrutos === 'string' ? config.ingresosBrutos : null,
    inicioActividades:
      typeof config.inicioActividades === 'string'
        ? config.inicioActividades
        : null,
  };
}
